import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
const HERO_IMG = 'https://cdn.magicpatterns.com/patterns/generated-images/d01a359a-331c-4154-ac91-387bb4258e3c.jpg';
export function Hero() {
  return <section id="top" className="relative w-full min-h-screen flex items-center overflow-hidden" data-id="element-78" data-mp="9l34tdl96e4i">
      {/* Background */}
      <div className="absolute inset-0" data-id="element-79" data-mp="4jvw9cbadaws">
        <img src={HERO_IMG} alt="African business skyline at golden hour" className="w-full h-full object-cover" data-id="element-80" data-mp="128frdnreylxt" />
        <div className="absolute inset-0 bg-navy/80" data-id="element-81" data-mp="x8jo5qqjiyjb" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy via-navy/40 to-navy/70" data-id="element-82" data-mp="s9zz3hgnh6mq" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 pt-32 pb-20 w-full" data-id="element-83" data-mp="nbey3ftkqix8">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.22, 1, 0.36, 1]
      }} className="max-w-3xl" data-id="element-84" data-mp="3d1sbczku5nu6">
          <div className="flex items-center gap-3 mb-6" data-id="element-85" data-mp="3j9k730lk2xau">
            <span className="h-px w-10 bg-gold" data-id="element-86" data-mp="3o7lprkf2kuls" />
            <span className="text-xs font-semibold tracking-widest uppercase text-gold" data-id="element-87" data-mp="3o6alzklmjmuo">
              Pan-African Growth Consultancy
            </span>
          </div>

          <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl leading-[1.05] text-ivory" data-id="element-88" data-mp="3e8wi0kgw0qj9">
            Igniting Growth
            <br data-id="element-89" data-mp="30h9crv4yw7oc" />
            <span className="text-gold" data-id="element-90" data-mp="30gq6jbooj7q5">Across Africa</span>
          </h1>

          <p className="mt-7 text-lg md:text-xl text-ivory/80 leading-relaxed max-w-xl" data-id="element-91" data-mp="359j9pv4i2804">
            We help ambitious brands grow through strategy, communications,
            partnerships, and media — with results you can measure.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4" data-id="element-92" data-mp="2vglq1lnruczx">
            <a href="#contact" className="group inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-gold text-navy font-semibold hover:bg-gold/90 transition-colors" data-id="element-93" data-mp="2hjoxnfs08ngx">
              Let's Build Together
              <ArrowRightIcon size={18} className="transition-transform group-hover:translate-x-1" data-id="element-94" data-mp="nb1kz5gpvtwy" />
            </a>
            <a href="#services" className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full border border-ivory/30 text-ivory font-semibold hover:bg-ivory/10 transition-colors" data-id="element-95" data-mp="i9vpizvo9sjq">
              Explore Our Services
            </a>
          </div>
        </motion.div>
      </div>

      {/* Bottom stat strip */}
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.7,
      delay: 0.3
    }} className="absolute bottom-0 inset-x-0 border-t border-ivory/10 bg-navy/40 backdrop-blur-sm" data-id="element-96" data-mp="11152xk8kd1gl">
        <div className="max-w-7xl mx-auto px-6 py-6 grid grid-cols-2 md:grid-cols-4 gap-6" data-id="element-97" data-mp="3hqu2ybi9aa1p">
          {[['Strategy', 'Roadmaps, not rate cards'], ['Communications', 'Brands people trust'], ['Media', 'Measurable performance'], ['Partnerships', 'Opportunities that matter']].map(([t, d]) => <div key={t} data-id="element-98" data-mp="268oblkph19t2">
              <p className="text-gold font-serif text-lg" data-id="element-99" data-mp="2b0pnh5iq8yik">{t}</p>
              <p className="text-ivory/60 text-sm mt-1" data-id="element-100" data-mp="2b20q320fs083">{d}</p>
            </div>)}
        </div>
      </motion.div>
    </section>;
}